package com.zi.support.shared

/** Generated from version.xcconfig by shared/build.gradle.kts; edit that file, not this one. */
object ReleaseInfo {
    const val VERSION = "1.11"
    const val BUILD = 15
    const val BUILD_DATE = "2026-11-03"
    val label: String get() = "Version $VERSION ($BUILD)"
}
